import { request, Paginated } from "utils/api";
import { Court } from "api/courts";

// fetch courts (GET /admin/clubs/courts)
export const getCourts = (data: {
    clubId?: string,
    limit?: number,
    offset?: number,
    query?: string,
    sortKey?: "clubName" | "courtName",
    sortOrder?: "ASC" | "DESC",
    sportForm?: string,
}) => request<Paginated<Court>>({
    data,
    endpoint: "/admin/clubs/courts",
    method: "get",
});

// edit courts (PATCH /admin/clubs/courts)
interface PatchCourtsParams {
    advanceBookingMins?: number,
    bookingPriceCents?: number,
    closeTimeMins?: number,
    courtDescription?: string,
    courtIds: string[],
    courtName?: string,
    courtNumber?: number,
    isAlwaysPaidBooking?: boolean,
    isBadWeatherSensitive?: boolean,
    isCommercialOnlyCourt?: boolean,
    minNumParticipants?: number,
    openTimeMins?: number,
    sportForms?: string[],
    surfaceType?: Court["surfaceType"],
    latitude?: number,
    longitude?: number,
}
export const patchCourts = (data: PatchCourtsParams) => request<Court[]>({
    data,
    endpoint: "/admin/clubs/courts",
    method: "patch",
});

// delete courts (DELETE /admin/clubs/courts)
export const deleteCourts = (data: {
    courtIds: string[],
}) => request<{}>({
    data,
    endpoint: "/admin/clubs/courts",
    method: "delete",
});

// create courts (POST /admin/clubs/courts)
export const postCourts = (data: {
    clubId: string,
}) => request<{}>({
    data,
    endpoint: "/admin/clubs/courts",
    method: "post",
});
